/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const imageCss = css({
  width: '100%',
  height: 'auto',
  marginBottom: 37,
  [MediaQueries.mdAndUp]: {
    marginBottom: 42,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 10,
  },
});

export const imageRightCss = css({
  display: 'flex',
  [MediaQueries.mdAndUp]: {
    order: 'unset',
  },
  [MediaQueries.lgAndUp]: {
    order: 2,
  },
  ['picture']: {
    flex: 1,
  },
});

export const headingCss = css(typography.effra48, {
  color: colorsPalette.grey,
  position: 'relative',
  fontWeight: fontWeights.medium,
  marginBottom: 16,
  [MediaQueries.lgAndUp]: {
    maxWidth: '85%',
  },
});

export const bodyCss = css(typography.effra18, {
  color: colorsPalette.grey,
  marginBottom: 24,
});

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.mdAndUp]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const containerPaddingCss = {
  padding: '64px 0',
  [MediaQueries.mdAndUp]: {
    padding: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    padding: '160px 0',
  },
};
